import {dirname} from '../../utils.ts';

function normalizePath(path: string): string {
  const parts: string[] = [];
  for (const part of path.split('/')) {
    if (!part || part === '.') continue;
    if (part === '..') {
      parts.pop();
    } else {
      parts.push(part);
    }
  }
  return parts.join('/');
}

/**
 * Crysknife project converts report document paths relative to the project
 * directory, while older responses may already contain repository-relative
 * paths. Return the first form that exists in the project group's file tree.
 */
export function resolveProjectSourcePath(
  sourcePath: string | undefined,
  projectPaths: Array<string | undefined>,
  knownPaths: ReadonlySet<string>,
): string | undefined {
  if (!sourcePath) return undefined;

  const candidates = [sourcePath, normalizePath(sourcePath)];
  for (const projectPath of projectPaths) {
    if (!projectPath) continue;
    candidates.push(normalizePath(`${dirname(projectPath)}/${sourcePath}`));
  }

  return candidates.find((candidate) => knownPaths.has(candidate));
}
